<div class="environment-details">
@if (headerLoading()) {
<section class="env-header">
  <div class="env-header__left">
    <div class="env-header__badges">
      <span class="env-header__sk env-header__sk--badge"></span>
      <span class="env-header__sk env-header__sk--badge"></span>
    </div>
    <h1><span class="env-header__sk env-header__sk--title"></span></h1>
    <p><span class="env-header__sk env-header__sk--text"></span></p>
  </div>
</section>
} @else if (error()) {
<section class="env-header">
  <p>{{ FEATURES.OVERVIEW_PAGE.LOADING }}</p>
</section>
} @else if (env(); as e) {
  <section class="env-header">
    <div class="env-header__left">
      <div class="env-header__badges">
        <span class="badge badge--class">CLASS {{ e.class }}</span>
        @if (e.status) {
        <span class="stage-status" [ngClass]="statusStyle[e.status]" [title]="statusLabels[e.status] | transloco">
          <span class="status-dot"></span>
          <span class="status-label">{{ statusLabels[e.status] | transloco }}</span>
        </span>
        }
      </div>
      <h1>
        @if (e.name) { {{ e.name }} } @else { <span class="env-header__sk env-header__sk--title"></span> }
      </h1>
      <p>
        @if (e.blueprint) { {{ e.blueprint }} } @else { <span class="env-header__sk env-header__sk--text"></span> }
      </p>
    </div>
  </section>
  }
  <!-- tabs -->
  <nav class="env-tabs">
    <div class="env-tabs__list" role="tablist">
      @for (tab of tabs; track tab.id) {
      <div class="env-tabs__item" role="tab" tabindex="0" [class.active]="activeTab() === tab.id"
        [attr.aria-selected]="activeTab() === tab.id" (click)="selectTab(tab.id)" (keydown.enter)="selectTab(tab.id)">
        <mat-icon class="env-tabs__icon" [svgIcon]="tab.icon"></mat-icon>
        <span>{{ tab.label }}</span>
      </div>
      }
    </div>
  </nav>

  <section class="env-content">
    @switch (activeTab()) {
    @case ('overview') {
    <app-environment-overview [instance]="overviewInstance()" [blueprintName]="env()?.blueprint" [solutionName]="solutionName()"
      [releaseVersion]="releaseVersion()" [environmentName]="env()?.name" [envClass]="env()?.class" [isAMR]="isAMR()"
      [instanceLoading]="instanceLoading()" [solutionLoading]="solutionLoading()">
    </app-environment-overview>
    }
    @case ('endpoints') {
    <app-environment-endpoints [endpoints]="instance()?.endpoints ?? []" [isLoading]="instanceLoading()">
    </app-environment-endpoints>
    }
    @case ('release-packages') { <app-environment-release-package [envId]="envId"></app-environment-release-package> }
    @case ('live-monitoring') { <app-environment-monitoring [envId]="envId" [searchKey]="instance()?.randomSuffix"></app-environment-monitoring> }
    }
  </section>
</div>